import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export type ConfirmDialogType = 'delete' | 'modify';

export interface ConfirmDialogData {
  message: string;
  title?: string;
  type?: ConfirmDialogType;
}

@Component({
  selector: 'app-confirm-dialog',
  template: `
    <div class="confirm-dialog crm-dialog">
      <h2 mat-dialog-title>
        <mat-icon>warning</mat-icon>
        {{ data.title || 'Megerősítés' }}
      </h2>
      <div mat-dialog-content>
        <p>{{ data.message }}</p>
      </div>
      <div mat-dialog-actions>
        <button mat-button (click)="onCancel()">Mégse</button>
        @if (data.type === 'modify') {
          <button mat-raised-button class="modify-btn" (click)="onConfirm()">
            <mat-icon>edit</mat-icon>
            Módosítás
          </button>
        } @else {
          <button mat-raised-button color="warn" (click)="onConfirm()">
            <mat-icon>delete</mat-icon>
            Törlés
          </button>
        }
      </div>
    </div>
  `,
  styleUrls: ['./confirm-dialog.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
